import React from 'react';
import { Checkbox } from 'antd';
import PropTypes from 'prop-types';

const CustomCheckbox = ({ label, asterisk=false, customClass, bold, ...rest }) => {
  return (
    <div className={`custom-checkbox ${bold ? "text-bold" : ''}`}>
      <Checkbox className={`${customClass}`} {...rest}>{label}{asterisk ? <span className='color-asterisk'> *</span> : ''}</Checkbox>
    </div>
  );
};

CustomCheckbox.propTypes = {
  label: PropTypes.string.isRequired,
};

export default CustomCheckbox;
